module.exports = __webpack_public_path__ + "static/media/image_26.f4dde54b.png";